import THREE, {BufferGeometry, Group, LineBasicMaterial, TypedArray, Vector3} from 'three';
import {Line2} from 'three/examples/jsm/lines/Line2';
import utils from "../utils";
import {LineGeometry} from "three/examples/jsm/lines/LineGeometry";
import {LineMaterial} from "three/examples/jsm/lines/LineMaterial";

export function cube(size: number): Array<number> {

    const h: number = size * 0.5;

    const position: Array<number> = [];

    position.push(
            -h, -h, -h,
            -h, h, -h,
            h, h, -h,
            h, -h, -h,
            -h, -h, -h,

            -h, -h, h,
            -h, h, h,
            -h, h, -h,
            -h, h, h,

            h, h, h,
            h, h, -h,
            h, h, h,

            h, -h, h,
            h, -h, -h,
            h, -h, h,
            -h, -h, h,
    );

    return position;

}

function createWiredCube(geometry: LineGeometry, material: LineMaterial): Line2 {
    return new Line2(geometry, material);
}


export function createWiredGroup(geometry: LineGeometry, material: LineMaterial, cubeSize: number): Group {

    const group: Group = new Group();
    const takenPositions: { [key: string]: boolean; } = {};

    const currentPosition: Vector3 = new Vector3(-10, 0, -10);
    takenPositions[JSON.stringify(currentPosition)] = true;

    new Array(Math.max(1, utils.generateRandomNumber(100))).fill(1).forEach(() => {

        const wired = createWiredCube(geometry, material);

        function getNextPosition(): Vector3 {
            const nextPosition: Vector3 = currentPosition.clone();

            const {x, y, z} = nextPosition;
            while (JSON.stringify(nextPosition) in takenPositions) {

                const dice: number = Math.random();

                const neg: number = Math.random() > 0.5 ? -1 : 1;
                if (dice < 1 / 3) {
                    nextPosition.setX(x + neg * cubeSize)
                } else if (dice < 2 / 3) {
                    nextPosition.setY(y + neg * cubeSize);
                } else {
                    nextPosition.setZ(z + neg * cubeSize);
                }
            }
            currentPosition.copy(nextPosition);
            takenPositions[JSON.stringify(nextPosition)] = true;
            return nextPosition;
        }

        wired.position.copy(getNextPosition())

        group.add(wired)
    })
    group.position.setZ(-10);
    return group;
}


export function createDynamicShape(geometry: BufferGeometry, material: LineBasicMaterial, MAX_POINTS: number): THREE.Line {
    const line: THREE.Line = new THREE.Line(geometry, material);

    function updatePositions(): void {

        const positions: TypedArray = line.geometry.attributes.position.array;

        let x: number, y: number, z: number, index: number;
        x = y = z = index = 0;
        for (let i: number = 0, l: number = MAX_POINTS; i < l; i++) {

            positions[index++] = x;
            positions[index++] = y;
            positions[index++] = z;

            x += (Math.random() - 0.5) * 30;
            y += (Math.random() - 0.5) * 30;
            z += (Math.random() - 0.5) * 30;

        }
        line.geometry.setDrawRange(0, MAX_POINTS);
        line.geometry.attributes.position.needsUpdate = true;

        //@todo fix
        // @ts-ignore
        line.material.color.setHSL(Math.random(), 1, 0.5);
    }

    //@todo fix
    // @ts-ignore
    line.updatePositions = updatePositions;

    return line;
}
